/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react/jsx-props-no-spreading */
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import { Sidebar } from 'semantic-ui-react';

import Modal from '../components/shared/layout/modal/index';
import MetaData from '../../r/components/shared/metadata';
import Loader from '../components/shared/layout/loader';
import Footer from './shared/layout/footer';
import Navbar from './shared/layout/navbar';
import { getRoutePath } from '../utils';

const LazyNotFound = lazy(() => import('../../r/components/not-found'));
const LazyFeatures = lazy(() => import('./features/components'));
const LazyReport = lazy(() => import('./report/components'));

const App = () => {
	return (
		<Router basename="/e">
			<Sidebar.Pushable style={{ transform: 'unset' }}>
				<Sidebar.Pusher dimmed={false} style={{ overflow: 'unset' }}>
					<Navbar />
					
					<Switch>
						<MetaData>
							<Suspense fallback={<Loader isPageLoader />}>
								{/* Route index to features page for the moment until the main homepage is re-written in React. */}
								<Route exact path="/" render={(props) => <LazyFeatures {...props} />} />
								
								<Route exact path={getRoutePath('Report')} render={(props) => <LazyReport {...props} />} />
								<Route exact path={getRoutePath('Features')} render={(props) => <LazyFeatures {...props} />} />
								
								{/* NotFound component must be last entry */}
								<Route path="*" render={(props) => <LazyNotFound {...props} />} />
							</Suspense>
						</MetaData>
					</Switch>

					<Footer />
					<Modal />
				</Sidebar.Pusher>
			</Sidebar.Pushable>
		</Router>
	);
};

export default App;